import { AnchorHTMLAttributes, FC, ReactNode } from 'react';
import { ToastContentProps } from 'react-toastify';

import { XSvg } from './Icons/XSvg';
import { CheckSvg } from './Icons/CheckSvg';
import { WarningSvg } from './Icons/WarningSvg';

export type ToastAction = AnchorHTMLAttributes<HTMLAnchorElement> & {
    label: string | ReactNode;
};

export type ToastProps = ToastContentProps & {
    variant: 'success' | 'danger';
    label: string | ReactNode;
    action?: ToastAction;
};

export const Toast: FC<ToastProps> = ({
    variant,
    label,
    action,
    closeToast,
    toastProps,
}) => {
    const badgeContainerClassNameMap: Record<ToastProps['variant'], string> = {
        success: 'bg-brand-teal',
        danger: 'bg-brand-red',
    };

    const badgeIconMap: Record<ToastProps['variant'], ReactNode> = {
        success: <CheckSvg fill={undefined} className="fill-neutral-mid" />,
        danger: <WarningSvg className="[&_path]:fill-white" />,
    };

    return (
        <div className="flex flex-row items-center">
            <div
                className={
                    'w-[32px] h-[32px] rounded-[8px] flex flex-row items-center justify-center mr-[8px] ' +
                    badgeContainerClassNameMap[variant]
                }>
                {badgeIconMap[variant]}
            </div>
            <div className="flex-1 text-body-text text-brand-ocean">
                {label}
            </div>
            {action && (
                <div className="flex flex-row items-center mx-2">
                    <a
                        {...action}
                        className="underline text-body-text text-brand-ocean hover:text-brand-teal">
                        {action.label}
                    </a>
                </div>
            )}
            <button onClick={closeToast}>
                <XSvg width={18} height={18} />
            </button>
        </div>
    );
};
